<template>
  <div class="note-dialog">
    <el-dialog
      title="员工保备注信息"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose">
      <div v-loading="loading">
        <el-form :model="noteForm" :rules="rules" ref="noteForm" label-width="100px">
          <el-form-item label="添加备注：" prop="content">
            <el-input
              type="textarea"
              v-model="noteForm.content"
              placeholder="请输入备注内容"
              :rows="3">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addNote" :loading="submitLoading">添加备注</el-button>
          </el-form-item>
        </el-form>
        
        <el-divider>备注记录</el-divider>
        
        <el-table :data="noteList" border style="width: 100%">
          <el-table-column prop="created_at" label="时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDate(null, null, scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" width="120" align="center"></el-table-column>
          <el-table-column prop="content" label="备注内容" align="center"></el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/utils/formatter'

export default {
  name: 'Note',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      noteForm: {
        content: ''
      },
      rules: {
        content: [
          { required: true, message: '请输入备注内容', trigger: 'blur' }
        ]
      },
      noteList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
        this.getNoteList()
      }
    }
  },
  methods: {
    formatDate,
    initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.noteForm.order_id = this.rowData.id
        this.noteForm.user_id = this.rowData.user_id
      }
    },
    getNoteList() {
      this.loading = true
      // 这里应该调用获取备注列表接口
      // 模拟数据
      setTimeout(() => {
        this.noteList = [
          {
            id: 1,
            created_at: new Date(),
            operator: '管理员',
            content: '客户咨询保单详情'
          },
          {
            id: 2,
            created_at: new Date(Date.now() - 86400000),
            operator: '客服',
            content: '客户要求修改投保人信息'
          }
        ]
        this.total = this.noteList.length
        this.loading = false
      }, 500)
    },
    addNote() {
      this.$refs.noteForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          // 这里应该调用添加备注接口
          // 模拟接口调用
          setTimeout(() => {
            this.$message.success('备注添加成功')
            this.noteForm.content = ''
            this.getNoteList()
            this.submitLoading = false
          }, 1000)
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$refs.noteForm.resetFields()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getNoteList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNoteList()
    }
  }
}
</script>

<style lang="less" scoped>
.note-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>